(function () {

    'use strict';

    angular.module('asys')
        .component('asysHeader', {
            templateUrl: 'header/header.html',
            bindings: {
                cssClassMainWidth: '@cssClassMainWidth'
            },
            controller: HeaderController,
            controllerAs: 'headerVm'
        });

    HeaderController.$inject = [
        '$scope',
        '$log',
        '$cookies',
        '$modal',
        '$window',
        '$timeout',
        '$state',
        '$element',
        'lodash',
        'mediaQueries',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'AngebotUtilsService',
        'AuthenticationService',
        'IntegrationService',
        'FormatUtilsService',
        'LoadingIndicatorService',
        'NavigationService',
        'MiscUtilsService',
        'HtmlUtilsService'
    ];

    function HeaderController($scope, $log, $cookies, $modal, $window, $timeout, $state, $element, _, mediaQueries, AppConfig, AngebotModel, BasisAngebotService, AngebotUtilsService, AuthenticationService, IntegrationService, FormatUtilsService, LoadingIndicatorService, NavigationService, MiscUtilsService, HtmlUtilsService) {
        var vm = this,
            lastOverlappingState,
            intersectionObserver,
            intersectionObserverEnabled = false,
            elemBeitragTarifauskunftsnummer,
            elemLogo;

        vm.$onInit = onInit;
        vm.$doCheck = doCheck;

        vm.getPKSLoginOptions = getPKSLoginOptions;
        vm.isBlockPksLoginErlaubt = isBlockPksLoginErlaubt;
        vm.onLogoClicked = onLogoClicked;
        vm.onClose = onClose;
        vm.isVermittlerTelefonnummerErlaubt = isVermittlerTelefonnummerErlaubt;
        vm.isBeitragTarifauskunftsnummerSichtbar = isBeitragTarifauskunftsnummerSichtbar;

        $scope.$on('asys:spaeterFortsetzen:showModal', function () {
            handleModalSpaterFortsetzen();
        });

        function onInit() {
            if ($window.document && $window.document.querySelectorAll && angular.isFunction($window.document.querySelectorAll)) {
                elemLogo = $window.document.querySelectorAll('.logo a')[0];
            }

            angular.element($window).bind('resize', onResize);
            angular.element($window).bind('scroll', onScroll);

            $scope.$on('$destroy', function () {
                angular.element($window).unbind('scroll', onResize);
                angular.element($window).unbind('resize', onScroll);
            });

            activate();

            if (!vm.isAppModus) {
                intersectionObserver = new IntersectionObserver(function (entries) {
                    if (entries[0].isIntersecting === true) {
                        angular.element(elemBeitragTarifauskunftsnummer).addClass('hidden');
                    } else {
                        angular.element(elemBeitragTarifauskunftsnummer).removeClass('hidden');
                    }
                }, {
                    threshold: 1.0,
                    rootMargin: '0px 0px 100px 0px'
                });
            }
        }

        function doCheck() {
            vm.isAppModus = MiscUtilsService.isAppModus();

            elemBeitragTarifauskunftsnummer = $window.document.querySelectorAll('header .beitragTarifauskunftsnummer')[0];
            if (NavigationService.getActive().type !== 'EXIT') {
                vm.vermittlerTelefonnummerErlaubt = isVermittlerTelefonnummerErlaubt();

                getTelefonnummer();
                getPKSLoginOptions();
            }

            if (!vm.isAppModus) {
                if (document.querySelector('#ergebnisBeitragTarifauskunftInfo')) {
                    if (!intersectionObserverEnabled) {
                        intersectionObserverEnabled = true;
                        intersectionObserver.observe(document.querySelector('#ergebnisBeitragTarifauskunftInfo'));
                    }

                    vm.gesamtbeitragTitle = AngebotUtilsService.getErgebnisSeiteTitle(vm.angebotModel.angebot);
                    vm.gesamtbeitragZuZahlweise = BasisAngebotService.getGesamtbeitragZuZahlweise(vm.angebotModel.angebot, true);
                } else {
                    intersectionObserverEnabled = false;
                }
            }

            vm.isBeitragLoading = _.size(BasisAngebotService.berechneServiceInProgress) > 0;
        }

        function activate() {
            vm.angebotModel = AngebotModel.get() || {};

            getTelefonnummer();

            vm.pksLoginOptions = {};
            vm.isAppModus = MiscUtilsService.isAppModus();
            vm.angebotsnummer = BasisAngebotService.getAngebotsnummer(vm.angebotModel.angebot, true);
        }

        function getTelefonnummer() {
            var phoneNumber = vm.vermittlerTelefonnummerErlaubt ? $cookies.get('agent_telephone') : (BasisAngebotService.isPrivatPerson(AngebotModel.get().angebot) ? AppConfig.APP.telefon : AppConfig.APP.telefonFirmenkunde);

            vm.phoneNumber = {
                display: FormatUtilsService.formatPhoneNumber(phoneNumber, {
                    removeInterantional: true,
                    replaceWhitespaceWithNonBreakingSpace: true
                }),
                call: 'tel:' + FormatUtilsService.formatPhoneNumber(phoneNumber, {
                    internationalCode: '+49'
                })
            };
        }

        function getPKSLoginOptions() {
            if (isBlockPksLoginErlaubt()) {
                _.merge(vm.pksLoginOptions, NavigationService.getActive().pksLoginOptions);
            }
        }

        function isVermittlerTelefonnummerErlaubt() {
            var vermittlerNummer = _.get(vm.angebotModel.angebot, 'allgemeineDaten.vermittlernummer.id');

            return (
                !AuthenticationService.getSession().tokenLoginSession &&
                !IntegrationService.getIntegrationParams().isTokenLogin &&
                $cookies.get('agent_telephone') &&
                MiscUtilsService.isNotEmpty(vermittlerNummer) &&
                vermittlerNummer !== '0'
            );
        }

        function isBlockPksLoginErlaubt() {
            return AngebotUtilsService.isBlockPksLoginErlaubt(vm.angebotModel);
        }

        function openModalSpaeterFortsetzen() {
            var modalAngebotFortsetzen = $modal.open({
                templateUrl: 'modal/modalAngebotFortsetzen.html',
                windowClass: 'medium',
                controller: 'ModalAngebotFortsetzenController',
                controllerAs: 'modalVm',
                resolve: { /* @ngInject */
                    options: [function () {
                        return {
                            showButtonExit: true
                        };
                    }]
                }
            });

            modalAngebotFortsetzen.result.then(function (action) {
                focusElementAfterCloseModal();

                $timeout(function () {
                    if (_.includes(['copyUrl', 'email', 'exit'], action)) {
                        AngebotUtilsService.handleCloseAndNavigation(vm.angebotModel);
                    }
                }, (action === 'email' ? 2000 : 0));
            }).catch(function (error) {
                focusElementAfterCloseModal();
            });
        }

        function handleModalSpaterFortsetzen() {
            var currentState = _.get($state, 'current') || {},
                activeStep = NavigationService.getActive() || {},
                angebotsnummerVorhanden = !!_.get(vm.angebotModel.angebot, 'angebotsnummer.id');

            if (
                activeStep.angebotEmail === false &&
                activeStep.angebotLink === false ||
                !_.get(vm.angebotModel, 'tarif.tarifkuerzel') ||
                _.get(vm.angebotModel, 'isDummyModel') ||
                currentState.parent === 'fehler' ||
                !BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, 'ANTRAG')
            ) {
                AngebotUtilsService.handleCloseAndNavigation(vm.angebotModel);
                return;
            }

            BasisAngebotService.mapFormToServiceData(vm.angebotModel.formData, vm.angebotModel.angebot, vm.angebotModel.angebotInitial, true);

            if (!angebotsnummerVorhanden || BasisAngebotService.hatAenderungen(vm.angebotModel.angebot, vm.angebotModel.angebotLetzteSpeicherung)) {
                LoadingIndicatorService.addInProgress();
                BasisAngebotService.speichere(vm.angebotModel, {
                    globalErrorsIgnore: {
                        errors: true,
                        nachrichten: true
                    },
                    httpErrorsIgnore: true
                }).then(function (data) {
                    $log.debug('AngebotController.speichereAngebot BasisAngebotService.speichere SUCCESS');

                    if (data.angebot) {
                        vm.angebotModel.angebot = angular.merge({}, data.angebot);
                    }

                    openModalSpaeterFortsetzen();
                }).catch(function (error) {
                    AngebotUtilsService.handleCloseAndNavigation(vm.angebotModel);
                    $log.error('AngebotController.speichereAngebot BasisAngebotService.speichere FAILURE', error);
                }).finally(function () {
                    LoadingIndicatorService.removeInProgress();
                });
            } else {
                openModalSpaeterFortsetzen();
            }
        }

        function onLogoClicked() {
            handleModalSpaterFortsetzen();
        }

        function onClose() {
            handleModalSpaterFortsetzen();
        }

        function handleOverlappingLogo(overlappingElem) {
            if (!elemLogo) {
                lastOverlappingState = false;
                return;
            }

            if (!mediaQueries.large()) {
                angular.element(elemLogo.querySelectorAll('.wgv-logo-subtitle')[0]).removeClass('show-override');
                angular.element(elemLogo.querySelectorAll('.wgv-logo-subtitle')[0]).removeClass('hide-override');
                angular.element(elemLogo.querySelectorAll('.wgv-logo-small')[0]).removeClass('hide-override');
                angular.element(elemLogo.querySelectorAll('.wgv-logo-small')[0]).removeClass('show-override');
                angular.element($element[0].querySelectorAll('header')[0]).removeClass('show-small-logo');
                lastOverlappingState = false;
                return;
            }

            var elemLogoOverrides = {
                    bottom: 124
                },
                isOverlapping = false;

            isOverlapping = _.some(_.compact([
                overlappingElem,
                window.document.querySelectorAll('iplusjs-alert')[0],
                $window.document.querySelectorAll('iplusjs-fieldset')[0],
                $window.document.querySelectorAll('div.fieldset')[0]
            ]), function (elem) {
                return HtmlUtilsService.elementsOverlapping(elemLogo, elem, elemLogoOverrides);
            });

            if (elemLogo && isOverlapping) {
                if (lastOverlappingState !== true) {
                    angular.element(elemLogo.querySelectorAll('.wgv-logo-subtitle')[0]).addClass('hide-override');
                    angular.element(elemLogo.querySelectorAll('.wgv-logo-subtitle')[0]).removeClass('show-override');
                    angular.element(elemLogo.querySelectorAll('.wgv-logo-small')[0]).addClass('show-override');
                    angular.element(elemLogo.querySelectorAll('.wgv-logo-small')[0]).removeClass('hide-override');
                    angular.element($element[0].querySelectorAll('header')[0]).addClass('show-small-logo');
                }

                lastOverlappingState = true;
            } else {
                if (lastOverlappingState !== false) {
                    angular.element(elemLogo.querySelectorAll('.wgv-logo-subtitle')[0]).addClass('show-override');
                    angular.element(elemLogo.querySelectorAll('.wgv-logo-subtitle')[0]).removeClass('hide-override');
                    angular.element(elemLogo.querySelectorAll('.wgv-logo-small')[0]).addClass('hide-override');
                    angular.element(elemLogo.querySelectorAll('.wgv-logo-small')[0]).removeClass('show-override');
                    angular.element($element[0].querySelectorAll('header')[0]).removeClass('show-small-logo');
                }

                lastOverlappingState = false;
            }
        }

        function focusElementAfterCloseModal() {
            if (!$element || !$element[0] || !$element[0].querySelector('.logo a')) {
                return;
            }

            $element[0].querySelector('.logo a').focus();
        }

        function onScroll() {
            handleOverlappingLogo();
        }

        function onResize() {
            handleOverlappingLogo();
        }

        function isBeitragTarifauskunftsnummerSichtbar() {
            return (
                NavigationService.getActive().name === 'rechner.ergebnis' &&
                BasisAngebotService.beitraegeVorhanden(vm.angebotModel.angebot)
            );
        }
    }

})();
